import styled from 'styled-components';

interface IContainerProps {
  height?: any;
  top?: any;
  padding?: string;
  backgroundColor?: string;
}

export const Container = styled.div`
`

export const Header = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 100vw;
  position: fixed;
  left: 0px;
  top: 0px;
  padding: ${props => props.padding || '0px'};
  background-color: ${props => props.backgroundColor || 'transparent'};
`;

export const BodyHeader = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 100vw;
  position: fixed;
  left: 0px;
  top: ${props => props.top || '0px'};
  overflow-y: hidden;
  overflow-x: hidden;
  padding: ${props => props.padding || '0px'};
  background-color: ${props => props.backgroundColor || 'transparent'};
`;

export const Body = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 100vw;
  height: ${props => props.height || '100vh'};
  max-height: ${props => props.height || '100vh'};
  position: fixed;
  left: 0px;
  top: ${props => props.top || '0px'};
  overflow-y: scroll;
  overflow-x: hidden;
  padding: ${props => props.padding || '0px'};
  background-color: ${props => props.backgroundColor || 'transparent'};
`;

export const Footer = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 100vw;
  position: fixed;
  left: 0px;
  bottom: 0px;
  padding: ${props => props.padding || '0px'};
  background-color: ${props => props.backgroundColor || 'transparent'};
`;